// extracted by mini-css-extract-plugin
export default {"container":"BulkRecommission_container__CiRFA"};